import { useEffect } from 'react'

import { deepSetObject, toggleArray } from '@domain-group/javascript-utils'

import {
  Box, ListItem, SectionDivider, Text, ToggleButton,
} from '@domain-group/suit-theme'

import type { UseBrandFormPayload } from '@hooks/useBrand'

interface WatermarkSettingTogglesProps {
  entityState: object,
  setEntityState: UseBrandFormPayload['setEntityState'],
  isWatermarkOnExport: boolean,
  isWatermarkOnSoldOrLeased: boolean,
  watermark_images: string[],
}

const WatermarkSettingToggles = (props: WatermarkSettingTogglesProps) => {
  const {
    entityState,
    isWatermarkOnExport,
    isWatermarkOnSoldOrLeased,
    setEntityState,
    watermark_images,
  } = props

  const updateWatermarkOnExport = () => {
    const updatedWatermarkOnExport = deepSetObject(
      entityState,
      'options.watermark_images',
      // @ts-expect-error TS2345
      toggleArray(watermark_images, 'export'),
    )
    // @ts-expect-error TS2345
    setEntityState(updatedWatermarkOnExport)
  }

  useEffect(() => {
    // reset if export is turned off to ensure default watermark_export_options is 'always'
    if (!isWatermarkOnExport && isWatermarkOnSoldOrLeased){
      const filteredSettings = watermark_images.filter(item => item !== 'sold_or_leased')
      const updatedState = {
        ...entityState,
        options: {
          ...(entityState as any).options,
          watermark_images: filteredSettings,
        },
      }
      setEntityState(updatedState as object)
    }
  }, [isWatermarkOnExport])

  return (
    <>
      <SectionDivider boxProps={{ marginTop: 'large', marginBottom: 'small' }}>WATERMARK SETTINGS</SectionDivider>

      <ListItem
        boxProps={{
          alignItems: 'center', justifyContent: 'space-between', marginTop: 'small',
        }}
        disableHover
      >
        <Text fontSize="small">Watermark on Export</Text>

        <ToggleButton
          onClick={() => updateWatermarkOnExport()}
          toggleOn={isWatermarkOnExport}
          toggleOffText="No"
          toggleOnText="Yes"
        />
      </ListItem>

      {isWatermarkOnExport && (
      <Box flexDirection="column" gap="medium" marginBottom="medium">
        <Box gap="medium" paddingY="small" alignItems="center">
          <input
            checked={!isWatermarkOnSoldOrLeased}
            id="always"
            name="watermark_export_options"
            onChange={() => {
              const updatedState = deepSetObject(
                entityState,
                'options.watermark_images',
                // @ts-expect-error TS2345
                toggleArray(watermark_images, 'sold_or_leased'),
              )
              setEntityState(updatedState as object)
            }}
            style={{ alignSelf: 'center', margin: '0', accentColor: 'green' }}
            type="radio"
            value="always"
          />

          <Text
            as="label"
            color="bodyFontLightColor"
            fontSize="small"
            labelFor="always"
            marginLeft="medium"
          >
            Always
          </Text>
        </Box>

        <Box gap="medium" paddingY="small" alignItems="center" marginTop="medium">
          <input
            checked={isWatermarkOnSoldOrLeased}
            id="sold_or_leased"
            name="watermark_export_options"
            onChange={() => {
              const updatedState = deepSetObject(
                entityState,
                'options.watermark_images',
                // @ts-expect-error TS2345
                toggleArray(watermark_images, 'sold_or_leased'),
              )
              setEntityState(updatedState as object)
            }}
            style={{ alignSelf: 'center', margin: '0', accentColor: 'green' }}
            type="radio"
            value="sold_or_leased"
          />

          <Text
            as="label"
            color="bodyFontLightColor"
            fontSize="small"
            labelFor="sold_or_leased"
            marginLeft="medium"
          >
            Only when campaign is marked as sold/leased
          </Text>
        </Box>
      </Box>
      )}
    </>
  )
}

export default WatermarkSettingToggles
